import { render, staticRenderFns } from "./DashboardKPI.vue?vue&type=template&id=377229ec&scoped=true&"
import script from "./DashboardKPI.vue?vue&type=script&lang=js&"
export * from "./DashboardKPI.vue?vue&type=script&lang=js&"
import style0 from "./DashboardKPI.vue?vue&type=style&index=0&id=377229ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377229ec",
  null
  
)

export default component.exports